<template>
<v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    :nudge-right="40"
    :return-value.sync="itemValue"
    transition="scale-transition"
    offset-y
    full-width
    max-width="290px"
    min-width="290px"
  >
    <v-text-field
      slot="activator"
      v-model="itemValue"
      :label="item.label"
      :placeholder="item.placeholder || undefined"
      :disabled="item.disabled || false"
      :rules="item.rules || []"
      :required="item.required || false"
      prepend-icon=""
      readonly
    ></v-text-field>
    <v-time-picker
       format="24hr"
      v-show="!item.disabled"
      :color="item.color || 'primary'"
      locale="es" v-model="itemValue" @change="$refs.menu.save(itemValue)"></v-time-picker>

  </v-menu>
</template>

<script>

'use strict'

export default {

  name: 'VuetifyTimePicker',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    item: {
      type: Object,
      default: null,
      required: true
    },
    value: {
      default: null
    }
  },

  data: () => ({
    itemValue: '',
    menu: false,
    dateFormatted: null
  }),

  created () {
    this.itemValue = this.item.value
  },

  watch: {
    itemValue: {
      handler: function (val, oldVal) {
        this.$emit('on-change', val, '', this.item, true)
      },
      deep: true
    },
    value: {
      handler: function (val, oldVal) {
        this.itemValue = val
        this.$emit('on-change', val, '', this.item, true)
      },
      deep: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/vuetify-form-creator/fields/vuetify-time-picker.vue